Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = reasonableNumber;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function reasonableNumberIsRequired(props, propName, componentName) {
  var value = props[propName];
  if (!Number.isFinite(value)) {
    return new RangeError(String(componentName) + ': ' + String(propName) + ' must be a finite number');
  }
  if (Object.is(value, -0)) {
    return new RangeError(String(componentName) + ': ' + String(propName) + ' can\'t be a negative zero');
  }

  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  return _propTypes2['default'].number.apply(_propTypes2['default'], [props, propName, componentName].concat(rest));
}

function reasonableNumber(props, propName) {
  if (props[propName] != null) {
    for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    return reasonableNumberIsRequired.apply(undefined, [props, propName].concat(rest));
  }
  return null;
}

reasonableNumber.isRequired = reasonableNumberIsRequired;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/reasonableNumber.js
// module id = 449
// module chunks = 168707334958949